import { jsxJoin } from "helpers/system";

import Tooltip from "rc-tooltip";
import React, { CSSProperties } from "react";

const iconStyles: CSSProperties = {
    right: "-3px",
    border: 0,
    borderRadius: "50%",
    width: "11px",
    height: "11px",
    display: "inline-block",
    lineHeight: "11px",
    textAlign: "center",
    fontSize: "10px",
    background: "#1f8deb",
    fontWeight: "bold",
    color: "#fff",
    cursor: "pointer",
    position: "relative",
};

const iconComponents = {
    top: <sup style={iconStyles}>?</sup>,
    bottom: <sub style={iconStyles}>?</sub>,
    center: <div style={{ ...iconStyles, bottom: "1px" }}>?</div>,
};

type IconPosition = "top" | "center" | "bottom";
type IconPlacement = "top" | "left" | "right" | "bottom";

interface IconProps {
    text: string;
    maxWidth?: number;
    minWidth?: number;
    placement?: IconPlacement;
    position?: IconPosition;
}

const InfoIcon = ({ text, maxWidth = 350, minWidth, placement = "top", position = "center" }: IconProps) => {
    return (
        <Tooltip
            styles={{
                body: {
                    maxWidth,
                    minWidth,
                },
            }}
            overlay={Array.isArray(text) ? jsxJoin(text, <br />) : text}
            placement={placement}
        >
            {iconComponents[position]}
        </Tooltip>
    );
};

export default InfoIcon;
